module.exports = __webpack_public_path__ + "static/media/controller.36e05148.png";